<script setup lang="ts">
defineSlots<{ default(): any }>()
</script>

<template>
  <div class="z-20 mr-2 rounded px-2 py-1 text-xs">
    <slot />
  </div>
</template>
